import H5JsApi, { SdkType } from '@fx-ui/h5-jsapi';

const { jssdk_integrate } = window.jdy_config.function_map ?? {};

export const h5JsApi = new H5JsApi({
    // 业务侧指定当前产品可用的jssdk
    allowMap: {
        [SdkType.DingTalk]: jssdk_integrate?.DingTalk,
        [SdkType.WxWork]: jssdk_integrate?.WxWork,
        [SdkType.Lark]: jssdk_integrate?.Lark,
        [SdkType.WeChat]: jssdk_integrate?.wechat,
        [SdkType.Jodoo]: jssdk_integrate?.jodoo,
        [SdkType.Jdy]: jssdk_integrate?.jdy
    }
});
